import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GetbyorderidComponent } from './getbyorderid/getbyorderid.component';
import { MandoobsstatmentComponent } from './mandoobsstatment/mandoobsstatment.component';
import { MandoobStatment } from './mandoobstatment.model';
import { MandoobstransComponent } from './mandoobstrans/mandoobstrans.component';
import { OrdersMandoobPrivateComponent } from './orders-mandoob-private/orders-mandoob-private.component';
import { OrdersbycategoryComponent } from './ordersbycategory/ordersbycategory.component';
import { OrdersbyproductComponent } from './ordersbyproduct/ordersbyproduct.component';
import { OrdersbysubcategoryComponent } from './ordersbysubcategory/ordersbysubcategory.component';
import { OrdersbyuserComponent } from './ordersbyuser/ordersbyuser.component';
import { OrdersdirectchargedComponent } from './ordersdirectcharged/ordersdirectcharged.component';
import { OrdersreportsComponent } from './ordersreports/ordersreports.component';
import { ProductcardsreportComponent } from './productcardsreport/productcardsreport.component';
import { UsertransComponent } from './usertrans/usertrans.component';
import { UsertransallComponent } from './usertransall/usertransall.component';
import { ServicepayordersComponent } from './servicepayorders/servicepayorders.component';
import { MandoobcustomersDepositsComponent } from './mandoobcustomers-deposits/mandoobcustomers-deposits.component';
import { ProductcardsinventoryComponent } from './productcardsinventory/productcardsinventory.component';

const routes: Routes = [
  { path: "allByDate", component: OrdersreportsComponent },
  { path: "mandoobStatment", component: MandoobsstatmentComponent },
  { path: "ordersbycategorystatment", component: OrdersbycategoryComponent },
  { path: "ordersbysubcategorystatment", component: OrdersbysubcategoryComponent },
  { path: "ordersbyproductstatment", component: OrdersbyproductComponent },
  { path: "ordersmandoobprivatestatment", component: OrdersMandoobPrivateComponent },
  { path: "ordersbydirectcharged", component: OrdersdirectchargedComponent },
  { path: "ordersbyuser", component: OrdersbyuserComponent },
  { path: "usertrans", component: UsertransComponent },
  { path: "orderbyid", component: GetbyorderidComponent },
  { path: "productcardsreport", component: ProductcardsreportComponent },
  { path: "usertransall", component: UsertransallComponent },
  { path: "mandoobtrans", component: MandoobstransComponent },
  { path: "servicepayordersreport", component: ServicepayordersComponent },
  { path: "mandoobcustomersdeposits", component: MandoobcustomersDepositsComponent },
  { path: "productcardsinventory", component: ProductcardsinventoryComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportsRoutingModule { }
